export default __webpack_public_path__ + "static/media/PR-Card-bo-1.1560e385.jpg";